module.exports = __webpack_public_path__ + "img/高邑陶瓷.acae12fc.jpg";